module.exports = __webpack_public_path__ + "img/icon_map_32_on_100.74d86269.png";